import {
  FloatingBackButton,
  PageBackground,
  LogoBannerImage,
} from "globalComponents";
import React from "react";
import styled from "styled-components";
import Logo from "../../assets/logos/banner.png";
import { useHistory, useParams } from "react-router-dom";
import {
  Container,
  Title,
  StyledForm,
  SubmitButton,
  ButtonContent,
  Label,
  Input,
} from "globalComponents/FormComponents";
import axios from "axios";
import { errorHandler } from "globalResources/util";
import { isEmail } from "globalResources/validators";
import cookie from "js-cookie";
import { getTheme } from "Theme";
const theme = getTheme();

const DisclaimerText = styled.p`
  font-size: 0.9em;
  color: ${theme.MAIN_COLOR};
`;

const Password = () => {
  const history = useHistory();
  const { user } = useParams();
  const token = cookie.get("token");
  const [form, setForm] = React.useState({
    password: "",
    confirmPassword: "",
  });
  const [submitEnabled, setSubmitEnabled] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.password || form.password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    } else if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    } else {
      setError(null);

      try {
        await axios.patch("/root/password", { password: form.password });
        setSuccess(true);
        history.push("/onboarding");
      } catch (error) {
        const { message } = await errorHandler(error);
        setError(message);
        console.error("Error creating root user:", error);
      }
    }
  };

  return (
    <PageBackground>
      <FloatingBackButton onClick={() => history.goBack()}>
        Back
      </FloatingBackButton>
      <LogoBannerImage src={Logo} alt="Logo" />
      <Container>
        <Title>Update Your Password</Title>
        <StyledForm>
          <Label>Password</Label>
          <Input
            type="password"
            placeholder="Password"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <Label>Confirm Password</Label>
          <Input
            type="password"
            placeholder="Confirm Password"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit(e);
              }
            }}
            onChange={(e) =>
              setForm({ ...form, confirmPassword: e.target.value })
            }
          />
          <DisclaimerText>
            Passwords must contain at least 8 characters, including uppercase,
            lowercase, and special characters.
          </DisclaimerText>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <SubmitButton onClick={handleSubmit}>
            <ButtonContent>Set Password</ButtonContent>
          </SubmitButton>
        </StyledForm>
      </Container>
    </PageBackground>
  );
};
export default Password;
